import { render, staticRenderFns } from "./JoaDocSendingModal.vue?vue&type=template&id=a7e8e9e0&"
import script from "./JoaDocSendingModal.vue?vue&type=script&lang=js&"
export * from "./JoaDocSendingModal.vue?vue&type=script&lang=js&"
import style0 from "./JoaDocSendingModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports